import { FormEvent, useEffect, useRef, useState } from "react";
import styles from "./ChatInput.module.css";

interface ChatInputProps {
  placeholder: string;
  disabled: boolean;
  onSend: (text: string) => void;
}

export function ChatInput({ placeholder, disabled, onSend }: ChatInputProps) {
  const [value, setValue] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!disabled) inputRef.current?.focus();
  }, [disabled]);

  const submit = (e: FormEvent) => {
    e.preventDefault();
    const trimmed = value.trim();
    if (!trimmed || disabled) return;
    onSend(trimmed);
    setValue("");
  };

  return (
    <form onSubmit={submit} className={styles.form}>
      <span
        className={`${styles.caret} ${disabled ? styles.caretDim : ""}`}
        aria-hidden
      >
        ›
      </span>
      <input
        ref={inputRef}
        type="text"
        className={styles.input}
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        disabled={disabled}
        aria-label="chat with ripper"
        autoComplete="off"
        spellCheck={false}
      />
      <button
        type="submit"
        className={styles.submit}
        disabled={disabled || value.trim().length === 0}
        aria-label="send"
      >
        send
      </button>
    </form>
  );
}
